module.exports = __webpack_public_path__ + "static/media/loader.3148b67a.mp4";